import { legalEntityInfo, privacyPolicyContactParagraph } from '../legal/LegalEntityInfo';

export type InlinePart = { text: string; bold?: boolean };

export type SdkTableRow = { name: string; subject: string; dataType: string; purpose: string; link: string; };
export type PersonalInformationProtectNode = | { type: 'br' } | { type: 'sdk-table' } | { type: 'h1' | 'h2' | 'h3'; text: string } | { type: 'p'; text?: string; parts?: InlinePart[] };

export const personalInfoSdkTableRows: SdkTableRow[] = [
  {
    "name": "友盟SDK",
    "subject": "友盟同欣（北京）科技有限公司",
    "dataType":
      "设备信息（Android ID/IDFV/OAID/OpenUDID/GUID 等设备标识）、网络信息、推送 Token；本应用未向用户申请广告追踪（IDFA）授权",
    "purpose": "消息推送、手机号一键登录",
    "link": "https://www.umeng.com/page/policy"
  },
  {
    "name": "小米推送",
    "subject": "北京小米移动软件有限公司",
    "dataType": "识别设备信息",
    "purpose": "推送消息",
    "link": "https://dev.mi.com/console/doc/detail?pId=1822"
  },
  {
    "name": "华为",
    "subject": "华为终端有限公司",
    "dataType": "识别设备信息",
    "purpose": "推送消息",
    "link": "https://consumer.huawei.com/cn/privacy/privacy-policy/"
  },
  {
    "name": "OPPO推送",
    "subject": "广东欢太科技有限公司",
    "dataType": "识别设备信息",
    "purpose": "推送消息",
    "link": "https://open.oppomobile.com/wiki/doc#id=10288"
  },
  {
    "name": "vivo推送",
    "subject": "维沃移动通信有限公司",
    "dataType": "识别设备信息",
    "purpose": "推送消息",
    "link": "https://www.vivo.com.cn/about-vivo/privacy-policy"
  },
  {
    "name": "神策",
    "subject": "神策网络科技（北京）有限公司",
    "dataType": "识别设备信息、网络状态",
    "purpose": "数据统计分析",
    "link": "https://www.sensorsdata.cn/terms/privacy.html"
  },
  {
    "name": "支付宝",
    "subject": "支付宝（中国）网络技术有限公司",
    "dataType": "个人常用设备信息，识别设备信息",
    "purpose": "实名认证",
    "link": "https://render.alipay.com/p/c/k2cx0tg8"
  },
  {
    "name": "微信登录",
    "subject": "深圳市腾讯计算机系统有限公司",
    "dataType": "个人常用设备信息",
    "purpose": "微信登录服务",
    "link": "https://www.wechat.com/zh_CN/privacy_policy.html"
  },
  {
    "name": "微信分享",
    "subject": "深圳市腾讯计算机系统有限公司",
    "dataType": "设备存储信息",
    "purpose": "帮助用户分享内容至第三方应用",
    "link": "https://www.wechat.com/zh_CN/privacy_policy.html"
  },
  {
    "name": "腾讯浏览服务",
    "subject": "深圳市腾讯计算机系统有限公司",
    "dataType": "设备存储信息",
    "purpose": "帮助用户查看各种格式的文件",
    "link": "https://privacy.qq.com/policy/tencent-privacypolicy"
  }
];

export const personalInformationProtectNodes: PersonalInformationProtectNode[] = [
  {
    "type": "h1",
    "text": "个人信息保护政策"
  },
  {
    "type": "p",
    "text": "（2026年09月22日版本）"
  },
  {
    "type": "p",
    "text": "（2026年09月22日生效）"
  },
  {
    "type": "p",
    "text": "用户在注册、登录界面勾选同意的《隐私政策》即本《个人信息保护政策》，二者内容一致。"
  },
  {
    "type": "h2",
    "text": "提示条款"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": `用户的信任对我们非常重要，我们深知用户信息安全的重要性，我们将按照法律法规要求，采取安全保护措施，保护用户信息安全可控。鉴此，圆领平台（即${legalEntityInfo.platformScope}，以下简称“圆领平台”“圆领”或“本平台”、“我们”）制定本《个人信息保护政策》（以下简称“本政策”）并提醒用户：`,
        "bold": false
      },
      {
        "text": "在使用圆领网站的各项服务前，请用户务必仔细阅读并透彻理解本政策，在确认充分理解并同意后方使用相关产品和服务。一旦用户开始使用圆领服务并勾选本政策的同意选项后，将被视为对本政策内容的接受和认可。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "text": `如对本政策内容有任何疑问、意见或建议，用户可通过隐私保护专用邮箱 ${legalEntityInfo.privacyEmail} 或APP内客服与我们联系。`
  },
  {
    "type": "p",
    "text": `本政策的个人信息处理者为${legalEntityInfo.operatorName}，注册地址：${legalEntityInfo.registeredAddress}。`
  },
  {
    "type": "p",
    "text": "圆领平台尊重并保护用户信息，并且将以高度勤勉和审慎的义务对待这些信息。在用户注册和使用了圆领平台提供的服务时，本平台将按照本政策收集、处理及披露用户的信息。本平台希望通过本政策向用户清晰地介绍圆领平台对用户信息的处理方式，因此本平台建议用户完整地阅读本政策，以帮助用户了解维护自己相关权益的方式。"
  },
  {
    "type": "p",
    "text": "如果用户有任何疑问、意见或建议，请通过圆领平台提供的各种联系方式与我们联系。"
  },
  {
    "type": "p",
    "text": "本政策将帮助用户了解以下内容："
  },
  {
    "type": "p",
    "text": "一、本政策的适用范围"
  },
  {
    "type": "p",
    "text": "二、本平台如何收集和使用用户信息"
  },
  {
    "type": "p",
    "text": "三、本平台如何共享、转让、公开披露用户信息"
  },
  {
    "type": "p",
    "text": "四、用户业务数据和公开信息"
  },
  {
    "type": "p",
    "text": "五、用户如何管理用户信息"
  },
  {
    "type": "p",
    "text": "六、本平台如何使用cookie和同类技术"
  },
  {
    "type": "p",
    "text": "七、本平台如何保护和保存用户信息"
  },
  {
    "type": "p",
    "text": "八、未成年人及儿童个人信息的特别约定"
  },
  {
    "type": "p",
    "text": "九、本政策的更新"
  },
  {
    "type": "p",
    "text": "十、如何联系本平台"
  },
  {
    "type": "p",
    "text": "十一、软件隐私权限说明"
  },
  {
    "type": "h3",
    "text": "一、 本政策的适用范围"
  },
  {
    "type": "p",
    "text": "1.1除条文另外明确规定外，本政策适用于本平台所有服务。服务包括向用户提供页面浏览、网站登录服务，以及通过圆领平台向用户提供的技术服务。"
  },
  {
    "type": "p",
    "text": "1.2本政策不适用于其他第三方向用户提供的服务。例如，圆领平台的服务商依托云市场向用户提供服务时，用户向服务商提供的信息不适用本政策。"
  },
  {
    "type": "p",
    "text": "1.3需要特别说明的是，作为圆领平台的用户，若用户利用圆领平台的技术服务，为用户的用户再行提供服务，因用户的业务数据属于用户所有，用户应当另行与用户的用户签订协议约定数据保护的相关事宜。"
  },
  {
    "type": "p",
    "text": "1.4本政策所述的用户包含了个人用户和企业用户。除非本政策特别释明，本政策中关于个人信息处理活动的内容仅针对个人用户，企业用户信息的处理不受本政策的约束。"
  },
  {
    "type": "p",
    "text": "1.5定义"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "圆领平台：",
        "bold": true
      },
      {
        "text": `指圆领官网及相关站点（域名为：www.yuanling.com、www.superthem.com）、圆领APP（人才端/企业端）、圆领卖家版APP及相关应用程序。${legalEntityInfo.operatorName}（以下简称“${legalEntityInfo.operatorShortName}”或“我们”）是圆领平台的产品开发者、运营者及个人信息处理者。`,
        "bold": false
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "用户：",
        "bold": true
      },
      {
        "text": "使用、登陆、浏览圆领平台的相关企业或其他主体（以下简称“服务接受方”）和个人（以下简称“服务提供方”）的合称。",
        "bold": false
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "用户信息：",
        "bold": true
      },
      {
        "text": "用户信息是指用户注册圆领平台账户，使用圆领平台的服务以及圆领平台为了向用户提供服务，用户提交的或者圆领平台收集的用户会员类信息，如企业名称、姓名、主营业务、行业分类、通讯地址、联系方式等，具体详见隐私权政策第二条所述的信息",
        "bold": false
      }
    ]
  },
  {
    "type": "h3",
    "text": "二、 本平台如何收集和使用用户信息"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.1帮助用户成为本平台的会员",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.1.1当用户在圆领平台创建账户时，用户须向我们提供会员名，设置、确认用户的登录密码，提供用户在中华人民共和国境内手机号码，设置、确认用户的登录密码。用户提交的手机号码用于用户注册、登录、绑定账户、密码找回时接受验证码，并且作为用户与圆领平台指定的联系方式之一，用来接收相关业务通知（如新品上线、服务变更等）。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.1.2在用户注册完成圆领平台账户后，用户可以在账户“基本资料”一栏中继续填写用户的信息，包括（1）用户的会员身份类型（个人、企业）、单位名称（如果用户已完成实名认证，单位名称将会以用户的实名认证信息为准）、营业年限、企业规模、从事行业、主营业务、主要产品、网站域名、学历信息、个人服务经历;（2）联系信息（国家、所在地区、街道、联系电话、传真）。用户若不提供这些信息，将不会影响用户对某一具体技术服务的使用。用户提供的本条第（1）类信息，会帮助本平台更了解用户对于圆领平台服务需求，以便圆领有针对性的向用户推广、介绍产品；用户提供的本条第（2）类信息，圆领平台可能会利用如上方式向用户推广、宣传产品、邮寄业务通知（含账单）或与用户进行业务沟通。圆领在进行个性化推荐前，会进行个人信息保护影响评估，并对处理情况进行记录。您也有权拒绝本平台的个性化推荐服务，可在【我】-【设置】-【隐私设置】-【个性化推荐管理】中一键关闭个性化推荐功能；关闭后我们将停止基于您个人信息进行的个性化推荐，但您仍可使用非个性化的基础服务。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.1.3在用户注册完成圆领平台账户后，用户需在账号的管理控制台提交联系人信息，包括用户指定联系人的邮箱、手机号码以及联系人的职位。圆领平台将通过如上信息向用户推广、介绍产品，发送业务通知（含账单）或与用户进行业务沟通。用户完成注册用户后，应当进行实名认证，实名认证为《中华人民共和国网络安全法》所规定的义务。用户应提供服务账户对应的姓名、企业名称、身份证件、联系方式、通讯地址和其他必须的信息。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.1.4如果用户仅需使用圆领平台网站的浏览、搜索等基本服务，用户不需要注册成为本平台的会员及提供上述信息。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.2 向用户提供技术服务",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.2.1根据中华人民共和国相关法律，在用户使用具体的技术服务时，用户应通过其账号提供真实的身份信息。用户通过圆领平台账号提供真实身份信息的，圆领平台会为用户提供多种方式予以协助，用户应根据其身份属性选择适合的方式。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.2.1.1如用户通过支付宝实名认证来提供其身份信息的，用户需先行输入支付宝账户以及密码登录支付宝账户，通过将支付宝账户绑定用户的圆领平台账户完成实名认证，在完成实名认证后，用户即通过支付宝向圆领平台提交了用户的姓名（或单位主体名称）、身份证号码（或营业执照号码）。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.2.1.2如用户通过企业对公账号方式进行实名认证的，用户需向圆领平台提交用户的企业注册地区、企业性质、企业名称和营业执照注册号，以及银行账户信息（包括开户行、银行账号和开户人）。圆领平台将以用户提交的企业注册地区、企业性质、企业名称和营业执照注册号确认用户的实名信息，圆领平台仅将用户提供的银行账户信息（包括开户行、银行账号和开户人）作为实名认证时的打款账号。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.2.1.3如果用户通过人脸识别来进行实名认证的，用户需要向圆领平台提供面部特征的生物识别信息和用户身份证正、反面照片，生物识别信息是敏感个人信息，本平台将按照法律法规的要求采取严格的保护措施。在人脸识别前，本平台将单独弹窗通知用户，并在取得用户的单独同意后进行人脸识别，请注意，人脸识别不是实名认证的唯一方法，用户有权选择其他方式进行实名认证。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.2.2在用户使用服务过程中本平台会收集以下信息：",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "text": "2.2.2.1 设备信息：本平台会根据用户在软件安装及使用中授予的具体权限，接收并记录用户所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符IMEI、移动用户识别码IMSI、网络类型、MAC地址、设备制造商、SIM卡信息SIM State、SIM卡信息ICCID等软硬件特征信息）、应用信息（例如应用崩溃信息、通知开关状态、软件安装列表）、设备所在位置相关信息（例如IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）。本平台可能会将前面两类信息进行关联，以便本平台能在不同设备上为用户提供一致的服务。"
  },
  {
    "type": "p",
    "text": "2.2.2.2 日志信息：当用户使用本平台的网站或客户端提供的服务时，平台会自动收集用户对平台服务的详细使用情况，作为有关网络日志保存。例如用户的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及用户访问的网页记录等。请用户注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果本平台将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得用户同意或法律法规另有规定外，本平台会将该类个人信息做匿名化、去标识化处理。"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.2.2.3 用户账户的支持信息：基于用户使用圆领平台服务而产生的用户的咨询记录、报障记录和针对用户故障的排障过程（如通信或通话记录），圆领平台将通过记录、分析这些信息以便更及时响应用户的帮助请求，以及用于改进服务。本平台在向用户提供业务功能或具体服务时，本平台会按照本政策以及相应的产品服务协议的约定收集、使用、存储、对外提供及保护用户信息；超出本政策以及相应的产品服务协议约定收集用户信息的，本平台会另行向用户说明信息收集的范围与目的，并征得用户的同意后再收集相应服务所必要的用户信息；如用户选择不提供前述信息，将会影响到用户使用相应服务，但不会影响用户使用圆领平台的基本功能和其他产品或服务。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.2.2.4 相机、相册涉及的信息：当用户使用扫码登录、上传头像等功能时，用户需要相应开启读写存储、相机、相册权限来扫描、拍摄、上传照片。本平台会在用户使用相关功能前弹窗提示用户是否需要开启相应权限，本平台仅在用户同意后，收集处理相关信息。请用户注意，用户开启任一权限即代表用户同意本平台可以收集和使用该权限所对应的相关个人信息来为用户提供对应服务。如用户选择不提供前述信息，将会影响到用户使用相应功能，但不会影响用户使用圆领平台的基本功能和其他产品或服务。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.2.2.5 日历信息：当用户需要使用圆领平台的面谈功能，需要通过腾讯会议进行，选择同步日历信息至腾讯会议或将会议日程加入用户的系统日历时，需要获取用户的日历读写权利，否则无法完成会议日程信息的同步。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.2.2.6 银行账户信息：当用户需要在本平台进行费用结算时，用户需要向我们提供其真实有效的银行账户信息，如银行卡号、持卡人姓名、持卡人身份证号等。如用户选择不提供银行账户信息，将会影响到用户进行费用结算，但不会影响用户使用圆领平台的基本功能和其他产品或服务。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2.3 本平台出于如下目的，使用用户提交以及本平台收集的用户信息：",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "text": "2.3.1 为了向用户提供服务，本平台会收集使用用户的手机号，向用户发送信息、通知或与用户进行业务沟通，比如为保证服务完成所必须的手机号、验证码、使用服务时所必要的推送通知。"
  },
  {
    "type": "p",
    "text": "2.3.2 为了维护、改进服务，向用户提供更符合用户个性化需求的信息展示，本平台可能将来自圆领平台某项服务的用户信息与来自其他项服务的信息结合起来，做出特征模型并进行个性化推荐，向用户展示、推送信息和可能的商业广告，比如推送圆领平台产品的新闻以及市场活动及优惠促销信息、圆领平台合作第三方的推广信息，或其他用户可能感兴趣的内容。"
  },
  {
    "type": "p",
    "text": "2.3.3 本平台可能以用户信息统计数据为基础，设计、开发、推广全新的产品及服务；本平台会对平台的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息不包含用户的任何个人信息，如涉及个人信息的，本平台会事先通过单独弹窗等方式告知用户，并在取得用户的单独同意后再向其他主体提供。"
  },
  {
    "type": "p",
    "text": "2.3.4 为提高用户使用圆领平台及经营主体关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别账号异常状态，保护用户或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或圆领相关协议、规则的情况，本平台可能使用用户的会员信息、并整合设备信息、MAC地址、IP地址、有关网络日志以及关联公司、合作伙伴合法分享的信息，来判断用户账户及交易风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施。"
  },
  {
    "type": "p",
    "text": "2.3.5 为了预防恶意程序、保障运营质量及效率，本平台会收集使用用户的软件安装列表等应用信息、或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源等。"
  },
  {
    "type": "p",
    "text": "2.3.6 如超出收集用户信息时所声称的目的，或者在超出具有直接或合理关联的范围使用用户信息前，本平台会再次向用户告知并征得用户的同意。"
  },
  {
    "type": "p",
    "text": "2.4以下情形中，处理用户信息无需取得用户的同意："
  },
  {
    "type": "p",
    "text": "2.4.1为订立、履行个人作为一方当事人的合同所必需；"
  },
  {
    "type": "p",
    "text": "2.4.2为履行法定职责或者法定义务所必需；"
  },
  {
    "type": "p",
    "text": "2.4.3为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；"
  },
  {
    "type": "p",
    "text": "2.4.4为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；"
  },
  {
    "type": "p",
    "text": "2.4.5依照《个人信息保护法》的规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；"
  },
  {
    "type": "p",
    "text": "2.4.6法律、行政法规规定的其他情形。"
  },
  {
    "type": "h3",
    "text": "三、 本平台如何共享、转让、公开披露用户信息"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "3.1 共享",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "text": "本平台不会与其他组织和个人共享用户信息，但以下情况除外："
  },
  {
    "type": "p",
    "text": "3.1.1基于用户的要求或在获取用户单独同意的情况下共享：获得用户的单独同意后，本平台会与其他方共享用户信息。"
  },
  {
    "type": "p",
    "text": "3.1.2在法定情形下的共享：本平台可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享用户信息。"
  },
  {
    "type": "p",
    "text": "3.1.3为了促成交易或协助解决争议，某些情况下只有共享用户信息，才能促成交易或处理用户与他人的纠纷或争议，例如，在圆领平台创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，圆领平台有权决定并依法向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成。"
  },
  {
    "type": "p",
    "text": "3.1.4与授权合作伙伴共享：本平台可能委托受信赖的合作伙伴来提供服务，因此本平台可能会与合作伙伴共享某些用户信息，以提供更好的客户服务和优化用户体验，本平台的授权合作伙伴的具体信息请见《个人信息共享及转让明细》。我们仅会出于合法、正当、必要、特定、明确的目的共享用户信息，并且只会共享提供服务所必要的用户信息。本平台的合作伙伴无权将共享的用户信息用于任何其他用途。本平台在与其他授权合作伙伴共享用户信息前，会通过单独弹窗等方式告知用户信息接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，并在取得用户的单独同意后再进行共享。"
  },
  {
    "type": "p",
    "text": "3.1.5目前，本平台的授权合作伙伴包括如下类型：第三方SDK合作伙伴、供应商、服务提供商和其他合作伙伴。本平台将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供基础技术服务、提供咨询、分析等专业服务。"
  },
  {
    "type": "p",
    "text": "3.1.6请用户注意，SDK技术由本平台与合作的第三方机构提供并由其直接收集用户的个人信息，关于第三方SDK合作伙伴的身份、收集个人信息的目的、方式、范围等情况，请详见下表："
  },
  {
    "type": "sdk-table"
  },
  {
    "type": "p",
    "text": "前述第三方SDK合作伙伴收集和处理信息等行为遵守其自身的个人信息保护规定，而不适用于本政策。为了最大程度保障用户的信息安全，本平台建议用户在使用任何第三方SDK类服务前先行查看其个人信息保护规定。为保障用户的合法权益，如用户发现这等SDK或其他类似的应用程序存在风险时，建议用户立即终止相关操作并及时与本平台联系。"
  },
  {
    "type": "p",
    "text": "3.1.7 对本平台与之共享用户信息的公司、组织和个人，本平台会与其签署严格的保密协议以及信息保护约定，要求他们按照本政策以及其他任何相关的保密和安全措施来处理用户信息。"
  },
  {
    "type": "p",
    "text": "3.1.8 本平台在委托其他主体处理用户信息或者向其他主体提供用户信息的情况下，本平台会事先进行个人信息保护影响评估，并对处理情况进行记录。"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "3.2 转让",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "text": "本平台不会将用户信息转让给任何公司、组织和个人，但以下情况除外："
  },
  {
    "type": "p",
    "text": "3.2.1 基于用户的要求或在获取用户单独同意的情况下转让： 本平台可能会将用户信息转让给其他第三方。我们仅会出于合法、正当、必要、特定、明确的目的向可信赖的第三方转让用户信息，并且只会转让必要的用户信息。涉及向其他第三方转让的，本平台会通过弹窗等形式单独告知用户接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，在获得用户的单独同意后转让。"
  },
  {
    "type": "p",
    "text": "3.2.2 在平台经营者和权利人与其他法律主体者发生合并、分立、解散、被宣告破产等情形，或其他涉及整体业务的合并、分立情形时，如涉及到用户信息转让，本平台会告知用户接收方的名称或者姓名和联系方式，并要求新的持有用户信息的企业、组织或个人继续受本政策的约束并履行用户信息保护义务，若接收方变更本政策所述的处理目的、处理方式的，接收方需重新向用户征求同意。"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "3.3 公开披露",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "text": "本平台仅会在以下情况公开披露用户信息："
  },
  {
    "type": "p",
    "text": "3.3.1 基于用户的要求或获得用户的单独同意后，本平台会公开披露用户信息。比如经本平台通过弹窗等方式单独告知用户并取得用户单独同意后，本平台会在圆领平台相关页面选录及展示用户的姓名、头像照片、职位、擅长领域、薪资范围、服务履历、教育背景、您自行录制和上传的视频等信息，以促进聘用的达成。请您注意，您一旦上传并同意公开您的前述信息，在本平台注册的企业用户及其他个人用户将可以在本平台内进行浏览和查看。您也有权拒绝公开前述信息，但不会影响您使用圆领平台的基本功能和其他产品或服务。"
  },
  {
    "type": "p",
    "text": "3.3.2为保护本平台或公众的人身财产安全免遭侵害，本平台可能依据适用的法律或本平台相关协议、规则披露相关个人信息。例如，若用户作为云市场服务商销售假货或盗版商品，我们可能会公开披露用户的店铺主体信息与处罚情况。"
  },
  {
    "type": "p",
    "text": "3.3.3本平台在公开用户信息前，会进行个人信息保护影响评估，并对处理情况进行记录。"
  },
  {
    "type": "h3",
    "text": "四、 用户业务数据和公开信息"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "不同于用户信息，对于用户业务数据和公开信息，圆领将按如下方式处理：",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "4.1 用户业务数据",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "text": "4.1.1用户通过圆领平台提供的服务，加工、存储、上传、下载、分发以及通过其他方式处理的数据，均为用户业务数据，用户完全拥有用户业务数据。圆领平台作为云服务提供商，只会严格执行用户的指示处理用户的业务数据，除按与用户协商一致或执行明确的法律法规要求外，不对用户的业务数据进行任何非授权的使用、删除或披露。"
  },
  {
    "type": "p",
    "text": "4.1.2用户应对用户业务数据来源及内容负责，圆领平台提示用户谨慎判断数据来源及内容的合法性。因用户业务数据内容违反法律法规、部门规章或国家政策而造成的全部结果及责任均由用户自行承担。"
  },
  {
    "type": "p",
    "text": "4.1.3根据用户与圆领平台协商一致，圆领平台在用户选定的数据中心存储用户业务数据。圆领平台恪守对用户的安全承诺，根据适用的法律保护用户存储在圆领平台数据中心的数据。"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "4.2 公开信息",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "text": "4.2.1 公开信息是指用户公开分享的任何信息，任何人都可以在使用和未使用圆领平台服务期间查看或访问这些信息。例如用户在圆领开发者论坛发布的信息。"
  },
  {
    "type": "p",
    "text": "4.2.2 为使用圆领平台服务，可能存在用户必须公开分享的信息。例如云市场为构建诚信交易环境，用户的信用评价信息（星级、客户评价）需要被公开分享。"
  },
  {
    "type": "h3",
    "text": "五、 用户如何管理用户信息"
  },
  {
    "type": "p",
    "text": "5.1 用户信息的查阅、复制、转移"
  },
  {
    "type": "p",
    "text": "5.1.1用户可以登录圆领平台“管理控制台”通过如下方式查阅、复制其用户信息，但法律、行政法规规定应当保密或者不需要告知用户相关事项的除外："
  },
  {
    "type": "p",
    "text": "【我的】-【求职设置】、【个人主页】、【收款账户】"
  },
  {
    "type": "p",
    "text": "5.1.2若用户申请将其在本平台的用户信息转移给其他主体的，在符合国家网信部门规定的条件的情形下，本平台将提供转移的路径。"
  },
  {
    "type": "p",
    "text": "5.2 用户信息的更正、补充"
  },
  {
    "type": "p",
    "text": "5.2.1若用户发现其用户信息不准确或不完整的，用户有权在本平台通过如下方式更正、补充："
  },
  {
    "type": "p",
    "text": "【我的】-【求职设置】、【个人主页】、【收款账户】"
  },
  {
    "type": "p",
    "text": "本平台会对用户信息予以核实，并及时更正、补充。"
  },
  {
    "type": "p",
    "text": "5.2.2如果用户需要变更用户圆领平台账户的实名认证信息，用户需通过邮件或电话等方式联系圆领平台，按照圆领平台的指引操作。"
  },
  {
    "type": "p",
    "text": "5.3 用户信息的删除"
  },
  {
    "type": "p",
    "text": "在以下情形中，本平台将主动删除用户信息，用户也可以向本平台提出删除用户信息的请求，若删除用户信息从技术上难以实现的，本平台将停止除存储和采取必要的安全保护措施之外的处理："
  },
  {
    "type": "p",
    "text": "5.3.1处理目的已实现、无法实现或者为实现处理目的不再必要；"
  },
  {
    "type": "p",
    "text": "5.3.2本平台停止提供产品或者服务，或者保存期限已届满；"
  },
  {
    "type": "p",
    "text": "5.3.3用户撤回同意；"
  },
  {
    "type": "p",
    "text": "5.3.4本平台违反法律、行政法规或者违反约定处理个人信息；"
  },
  {
    "type": "p",
    "text": "5.3.5法律、行政法规规定的其他情形。"
  },
  {
    "type": "p",
    "text": "为保障安全，用户需要提供书面请求，或以其他方式证明用户的身份。圆领平台会先验证用户身份，经验证无误后再处理用户的请求。"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "5.4 每个业务功能需要一些基本的用户信息才能得以完成（详见本政策第二条）。除此之外，用户可以通过与圆领平台客服联系给予或撤回用户的同意。当用户撤回同意后，圆领平台将不再处理相应的用户信息。",
        "bold": false
      },
      {
        "text": "但用户撤回同意的决定，不会影响此前基于用户的同意而开展的用户信息处理。",
        "bold": true
      }
    ]
  },
  {
    "type": "p",
    "text": "5.5 帐号的注销"
  },
  {
    "type": "p",
    "text": "用户有权申请注销其在本平台的帐号。用户可以通过圆领/圆领之家APP进行自助注销，由系统进行自动审核，在确认满足注销的条件后予以注销，在本平台注销用户帐号后，本平台将停止为用户提供产品或服务，并根据法律法规的要求删除或对用户信息进行匿名化处理（法律法规另有规定的除外）。"
  },
  {
    "type": "p",
    "text": "5.5.1 帐号注销的路径"
  },
  {
    "type": "p",
    "text": "用户可以通过下列路径申请注销帐号："
  },
  {
    "type": "p",
    "text": "企业端（圆领APP）： 我的 -> 系统设置 -> 注销帐号"
  }, 
  {
    "type": "p",
    "text": "卖家端（圆领之家APP）：我的 -> 系统设置 -> 注销帐号"
  },
  {
    "type": "p",
    "text": "5.5.2 帐号注销的条件"
  },
  {
    "type": "p",
    "text": "5.5.2.1人才端需同时满足以下条件："
  },
  {
    "type": "p",
    "text": "（1）帐号不得关联企业帐号；"
  },
  {
    "type": "p",
    "text": "（2）帐号无任何进行中面谈行为；"
  },
  {
    "type": "p",
    "text": "（3）帐号无任何进行中合约行为；"
  },
  {
    "type": "p",
    "text": "（4）帐号处于安全状态，无被盗风险。"
  },
  {
    "type": "p",
    "text": "5.5.2.2企业端需同时满足以下条件："
  },
  {
    "type": "p",
    "text": "（1）帐号不得关联人才账号；"
  },
  {
    "type": "p",
    "text": "（2）帐号无任何进行中的合约行为；"
  },
  {
    "type": "p",
    "text": "（3）帐号处于安全状态无被盗风险;"
  },
  {
    "type": "p",
    "text": "（4）企业端用户需在申请注销帐号的同时一并申请对其帐号中的资产进行结算，如有余额的需一并申请退回。"
  },
  {
    "type": "p",
    "text": "5.5.3 帐号注销的处理时限：本平台将在用户申请注销帐号之日起的15个工作日内完成审核并告知用户结果；审核通过后，将停止提供服务并删除或匿名化您的个人信息（法律法规另有规定的除外）。"
  },
  {
    "type": "p",
    "text": "六、 本平台如何使用Cookie 和同类技术"
  },
  {
    "type": "p",
    "text": "6.1为确保本平台网站和应用正常运转、为用户获得更轻松的访问体验、向用户推荐用户可能感兴趣的内容，本平台会在用户的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。圆领平台只能读取圆领提供的Cookie。"
  },
  {
    "type": "p",
    "text": "6.2借助于 Cookie，能够存储用户的偏好或购买清单中的商品等数据。当下一次用户再次访问的时候，本平台将显示用户需要的信息；或由圆领平台通过Cookie文件来辨识用户的来源网站，以便圆领平台能追踪圆领的广告效果。"
  },
  {
    "type": "p",
    "text": "6.3 用户可根据自己的偏好管理Cookie，用户也可以清除计算机上保存的所有 Cookie。大部分网络浏览器都设有阻止 Cookie 的功能。但如果用户这么做，则需要在每一次访问本平台的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问用户使用的浏览器的相关设置页面。"
  },
  {
    "type": "p",
    "text": "6.4除 Cookie 外，圆领平台还会在网站上使用网站信标和像素标签等其他同类技术。例如，圆领平台向用户发送的电子邮件可能含有链接至圆领平台网站内容的地址链接，如果用户点击该链接，圆领平台则会跟踪此次点击，帮助圆领平台了解用户的产品或服务偏好以便于圆领平台主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，圆领平台能够获知电子邮件是否被打开。如果用户不希望自己的活动以这种方式被追踪，则可以随时从圆领平台的寄信名单中退订。"
  },
  {
    "type": "h3",
    "text": "七、本平台如何保护和保存用户信息"
  },
  {
    "type": "p",
    "text": "7.1圆领平台非常重视用户的信息安全。本平台努力采取各种合理的物理、电子和管理方面的安全措施来保护用户信息。防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。本平台会使用加密技术提高用户信息的安全性；本平台会使用受信赖的保护机制防止用户信息遭到恶意攻击；本平台会部署访问控制机制，尽力确保只有授权人员才可访问用户信息；以及圆领平台会举办安全和隐私保护培训课程，加强员工对于保护用户信息重要性的认识。"
  },
  {
    "type": "p",
    "text": "7.2 本平台会采取合理可行的措施，避免收集无关的用户信息。本平台只会按照法律法规的要求在达成本政策所述目的所需的最短期限内保留用户信息，比如按照《网络安全法》的规定，本平台需要采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月。超出上述用户信息保存期限后，本平台会对用户的个人信息进行删除或匿名化处理。"
  },
  {
    "type": "p",
    "text": "7.3请用户使用复杂密码，协助圆领平台保证用户的账号安全。本平台将尽力保障用户信息的安全。如果圆领平台的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致用户的合法权益受损，本平台将承担相应的法律责任。"
  },
  {
    "type": "p",
    "text": "7.4请用户理解，由于技术的限制以及可能存在的各种恶意手段，在互联网环境下，即便竭尽所能加强安全措施，也不可能始终保证数据百分之百的安全。用户需要了解，用户接入圆领平台的服务所用的系统和通讯网络，有可能因圆领平台可控范围外的因素而出现问题。在不幸发生用户信息安全事件（泄露、篡改、丢失）后，圆领平台将按照法律法规的要求立即采取补救措施，并通知履行个人信息保护职责的部门和用户，通知包括如下事项：发生或者可能发生个人信息泄露、篡改、丢失的信息种类、原因和可能造成的危害、圆领平台采取的补救措施和个人可以采取的减轻危害的措施、本平台的联系方式等。圆领平台将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知用户，难以逐一告知用户信息主体时，圆领平台会采取合理、有效的方式发布公告。"
  },
  {
    "type": "p",
    "text": "7.5同时，圆领平台还将按照监管部门要求，上报用户信息安全事件的处置情况。"
  },
  {
    "type": "p",
    "text": "7.6 本平台将收集到的用户信息存放在中华人民共和国境内，如在符合法律、行政法规或其他相关规定的情形下因业务等需要，确需向境外传输个人信息的，我们会事先通过弹窗或其他方式单独向用户告知用户信息出境的目的、接收方的名称或姓名、联系方式、处理方式、所涉用户信息的种类、安全保障措施、安全风险以及用户向境外接收方行使相关权利和程序等事项，并在征得用户的单独同意后再向境外提供用户信息。"
  },
  {
    "type": "p",
    "text": "7.7如出现圆领平台产品和服务停止运营的情形，本平台会采取合理措施保护用户信息安全，包括及时停止继续收集用户信息的活动；停止运营的通知将以逐一送达或公告的形式通知用户；并对所持有的个人信息进行删除或匿名化处理等。"
  },
  {
    "type": "h3",
    "text": "八、未成年人及儿童个人信息的特别约定"
  },
  {
    "type": "p",
    "text": "8.1 本平台主要面向成年人。若您未满18周岁，请在监护人陪同下阅读本政策，并在监护人同意的前提下使用我们的服务。"
  },
  {
    "type": "p",
    "text": "8.2 我们不会主动面向未满14周岁的儿童提供产品或服务，也不会故意主动收集未满14周岁儿童的个人信息。"
  },
  {
    "type": "p",
    "text": "8.3 若我们发现或接到举报称我们在未获得监护人同意的情况下收集了未满14周岁儿童的个人信息，我们将尽快核实并删除相关信息。"
  },
  {
    "type": "p",
    "text": "8.4 若您是儿童的监护人，对您所监护儿童的个人信息有相关疑问，或需行使查阅、复制、更正、删除等权利，请通过本政策第十条联系方式与我们联系。"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "8.5 若您未满18周岁且无法获得监护人同意，请立即停止使用本平台服务。",
        "bold": true
      }
    ]
  },
  {
    "type": "h3",
    "text": "九、个人信息保护政策的更新"
  },
  {
    "type": "p",
    "text": "9.1. 本平台的个人信息保护政策可能随时进行修订。"
  },
  {
    "type": "p",
    "text": "9.2 对于重大修订，本平台还会提供更为显著的通知（包括对于某些服务，我们会通过网站公示的方式进行通知或向用户进行弹窗提示，说明个人信息保护政策的具体变更内容）。"
  },
  {
    "type": "p",
    "text": "9.3 本政策所指的重大变更包括但不限于："
  },
  {
    "type": "p",
    "text": "9.3.1 圆领平台的服务模式发生变化。如处理用户信息的目的、处理的用户信息类型、用户信息的处理方式、保存期限等发生变更；"
  },
  {
    "type": "p",
    "text": "9.3.2 圆领平台在控制权、组织架构等方面发生重大变化。如业务调整、破产清算、并购等引起的所有者或运营者变更等；"
  },
  {
    "type": "p",
    "text": "9.3.3圆领平台信息共享、转让或公开披露的相关情形发生变化；"
  },
  {
    "type": "p",
    "text": "9.3.4用户行使《个人信息保护法》所规定权利的方式和程序发生变化；"
  },
  {
    "type": "p",
    "text": "9.3.5 圆领平台负责处理用户信息安全的责任部门、联系方式及投诉渠道发生变化时；"
  },
  {
    "type": "p",
    "text": "9.3.6 用户信息安全影响评估报告表明存在高风险时。"
  },
  {
    "type": "h3",
    "text": "十、如何联系本平台"
  },
  {
    "type": "p",
    "text": privacyPolicyContactParagraph
  },
  {
    "type": "h3",
    "text": "十一、软件隐私权限说明"
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "1、拍摄照片和视频",
        "bold": false
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "2、获取手机信息",
        "bold": false
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "3、录音",
        "bold": false
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "4、添加/修改日历活动",
        "bold": false
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "5、访问日历",
        "bold": false
      }
    ]
  },
  {
    "type": "p",
    "parts": [
      {
        "text": "6、读取或写入手机存储",
        "bold": false
      }
    ]
  }
];
